"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LocalizationServiceFacade = _interopRequireDefault(require("@ikea-aoa/ikea-shared-services/lib/facade/LocalizationServiceFacade"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles IkeaLocales
 */
var IkeaLocale = /*#__PURE__*/function () {
  /**
   * Class constructor.
   */
  function IkeaLocale() {
    _classCallCheck(this, IkeaLocale);

    this.availableLocales = IkeaLocale._getAvailableLocales();
  }
  /**
   * Gets array with locale objects that match specified country.
   *
   * @param {string} country Country to get locales for, two character string.
   * @returns {object[]} Each object in list describes the locale with country, language, and locale string.
   */


  _createClass(IkeaLocale, [{
    key: "getLocalesForCountry",
    value: function getLocalesForCountry(country) {
      if (!country) {
        return [];
      }

      return this.availableLocales.filter(function (locale) {
        return locale.country === country.toLowerCase();
      });
    }
    /**
     * Checks if specified country and language is a legal combination.
     *
     * @param {string} country Country code.
     * @param {string} language Language code.
     * @returns {boolean} True if language code matches one of the ones in country code, false if cc and lc combination is illegal.
     */

  }, {
    key: "isValidLocale",
    value: function isValidLocale(country, language) {
      var localesForCountry = this.getLocalesForCountry(country);
      var matchingLocale = localesForCountry.find(function (locale) {
        return locale.language === language;
      });
      return localesForCountry.length > 0 && matchingLocale !== undefined;
    }
    /**
     * Gets list of all available locales as objects.
     *
     * @returns {object} AvailableLocales List of available locale objects.
     */

  }, {
    key: "getCountry",

    /**
     * Gets country code from available locales.
     *
     * @param {string} locale String specifying both country and language.
     * @returns {(string | null)} Two letter country code or null if not found.
     */
    value: function getCountry(locale) {
      var availableLocale = this.availableLocales.find(function (l) {
        return l.locale.includes(locale);
      });
      return locale && availableLocale ? availableLocale.country : null;
    }
    /**
     * Gets language code from available locales.
     *
     * @param {string} locale String specifying both country and language.
     * @returns {(string | null)} Two letter language code or null if not found.
     */

  }, {
    key: "getLanguage",
    value: function getLanguage(locale) {
      var availableLocale = this.availableLocales.find(function (l) {
        return l.locale.includes(locale);
      });
      return locale && availableLocale ? availableLocale.language : null;
    }
  }], [{
    key: "_getAvailableLocales",
    value: function _getAvailableLocales() {
      var ikeaLocales = _LocalizationServiceFacade.default.getLocales();

      var availableLocales = [];

      for (var key in ikeaLocales) {
        var country = key.split('_')[1];
        var language = key.split('_')[0];
        var locale = ikeaLocales[key];
        availableLocales.push({
          country: country.toLowerCase(),
          language: language.toLowerCase(),
          locale: locale
        });
      }

      return availableLocales;
    }
  }]);

  return IkeaLocale;
}();

exports.default = IkeaLocale;